export const customCopilotEmailTemplate = {
  journeyHistory: {
    journeySummaryText:
      'Davis has previously completed travel booking on the website, with positive sentiment.',
    interactions: [
      {
        CustomerName: 'Davis Briliam',
        InteractionDateTime: '2023-7-20 10:22:00.000',
        InteractionDurationInSeconds: 172,
        InteractionOrigin: 'Customer Service',
        InteractionReason: 'Compare Plans',
        InteractionSentiment: 'Neutral',
        InteractionSummary:
          'The customer logged into the online portal to compare various travel plans',
        InteractionType: 'WebSiteVisit',
        IsResolved: true,
        StepsTakenDuringCall: 'Compare Plans',
      },
      {
        InteractionType: 'WebSiteVisit',
        InteractionReason: 'Book Travel Plan',
        InteractionDateTime: '2023-6-02 8:04:00.000',
        InteractionSentiment: 'Neutral',
        IsResolved: true,
        InteractionOrigin: 'Customer Service',
        StepsTakenDuringCall: 'Book Travel Plan',
        InteractionDurationInSeconds: 170,
        CustomerName: 'Davis Briliam',
        InteractionSummary:
          'The customer logged into the online portal to complete a travel booking to Europe',
      },
    ],
  },
  rtSummary: 'Davis called into customer support to report damaged luggage.',
  finalAutoSummary:
    'Customer wanted help report damaged luggage. Copilot generated an email response to help customer report damaged luggage.',
  agentTransferSummary:
    'Davis Called into customer support to report damaged luggage.',
  copilotAgentAndCustomerEmailData: [
    {
      messageFrom: 'copilot',
      recordType: 'sentiment',
      message: [
        {
          description:
            'Davis would like to know the process for filing a damaged luggage claim.',
        },
      ],
      sentimentScore: 1,
    },
    {
      messageFrom: 'copilot',
      recordType: 'emailResponseSuggested',
      message: [
        {
          generationDescription:
            'Wait a few seconds, Copilot is working on your generated response.',
          generationTitle: 'Reply is generating',
          subtitle: 'Generate Email Response',
          selectedTopicId:
            '40d68a1b-ba39-43d0-8511-bd1fb9769bc4,a3b89126-28dc-4a2a-8b49-9b40d1d6a792,afde3412-ad3e-4d2a-a20a-c0332c9a70a1,afde3412-ad3e-4d2a-a20a-c0332c9a70a2,afde3412-ad3e-4d2a-a20a-c0332c9a70a3,afde3412-ad3e-4d2a-a20a-c0332c9a70a4',
          emailTopics: [
            {
              content: 'Frustration with a recent flight',
              sentiment: 'Negative',
              topicId: '40d68a1b-ba39-43d0-8511-bd1fb9769bc4',
            },
            {
              content: 'Flight delay of three hours',
              sentiment: 'Negative',
              topicId: 'a3b89126-28dc-4a2a-8b49-9b40d1d6a792',
            },
            {
              content: 'Luggage disappearance',
              sentiment: 'Negative',
              topicId: 'afde3412-ad3e-4d2a-a20a-c0332c9a70a1',
            },
            {
              content: 'Luggage damage on delivery',
              sentiment: 'Negative',
              topicId: 'afde3412-ad3e-4d2a-a20a-c0332c9a70a2',
            },
            {
              content: 'Disappointment on care and handling of luggage',
              sentiment: 'Negative',
              topicId: 'afde3412-ad3e-4d2a-a20a-c0332c9a70a3',
            },
            {
              content: 'Damaged luggage claim process',
              sentiment: 'Negative',
              topicId: 'afde3412-ad3e-4d2a-a20a-c0332c9a70a4',
            },
          ],
        },
      ],
    },
    {
      messageFrom: 'copilot',
      recordType: 'emailResponseGenerated',
      message: [
        {
          title: 'Please wait...',
          description: 'Copilot is working on your generated response.',
        },
      ],
    },
    {
      messageFrom: 'copilot',
      recordType: 'emailResponseGenerated',
      message: [
        {
          title: 'Reply Generated',
          description:
            'An email message has been generated from the sources below.',
          kbLinks: [
            {
              text: 'Damaged Luggage Claim',
              link: 'https://www.google.com/',
            },
            {
              text: 'Filing a Claim',
              link: 'https://www.google.com/',
            },
            {
              text: 'Most Updated Claims Process',
              link: 'https://www.google.com/',
            },
          ],
        },
      ],
    },
    {
      messageFrom: 'copilot',
      recordType: 'suggestionArticleWithLinks',
      message: [
        {
          kbAnswers: {
            title: 'Obtaining a reference number',
            description:
              'Reference numbers are obtained at this link: www.delta.com/referencenumber or here through copilot on your request. Send the link to obtain a reference number.',
          },
          kbLinks: [
            {
              text: 'Obtaining a reference number',
              link: 'https://www.delta.com/referencenumber',
            },
            {
              text: 'The damaged luggage process',
              link: 'https://www.google.com/',
            },
          ],
          kbImages: [],
          kbProcessSteps: [],
        },
      ],
    },
  ],
};
